<!-- 
Users listing page.
-->
<template>
  <div class="home">
    <our-heading 
      :breadcrumbs="breadcrumbs"
      title="Users"
      user-guide-topic="administration-users"
    />
    <our-search-bar>
      <our-quick-search 
        slot="quick-search"
        :criteria-mutation="criteriaMutation" 
        :value="criteria.emailAddress"
        label="User email" 
        field="emailAddress" 
        @changed="$refs.listing.refresh()"
      />
      <our-search-button 
        slot="search-button"
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search users"
        show-all
        @changed="$refs.listing.refresh()"
      />
      <our-saved-searches-menu
        slot="saved-searches-button"
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="prismsUsers" 
        @selected="$refs.listing.refresh()"
      />
    </our-search-bar>
    <prisms-user-listing ref="listing"/>
  </div>
</template>

<script>
import PrismsUserListing from "@/components/prisms-users/PrismsUserListing.vue";
import * as mutation from "@/store/prisms-users/mutation-types";
import { getSearchFilters } from "@/store/prisms-users/helpers";

export default {
  name: "Users",
  components: { PrismsUserListing },
  data() {
    return {
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA,
      breadcrumbs: [{ text: "Users" }]
    };
  },
  computed: {
    searchFilters() {
      return getSearchFilters();
    },
    criteria() {
      return this.$store.state.prismsUsers.listing.criteria;
    }
  }
};
</script>
